<template>  
    <section class="order-wrap">
		<common-modal :showClose="true" v-if="isShowTips" @close-modal="onCloseModalClick">
		    <div class="tips-all">增加此权限给于处理人员更多的权限，可提高处理效率及成功率。</div>
		</common-modal>	
		
		<!-- 服务项目弹框 -->
		<common-modal :showClose="false" v-if="isShowService" @close-modal="onCloseModalClick" class="service-wrap">
		    <div class="modal service-box">
		    	<div class="title service-h1">亲，需要什么服务呢？</div>
		        <ul class="service-detail have-border" :class='serveMore?"service-more":""'>
					<li class="detail" :class='serveFlag==index?"select":""' v-for='(item,index) in serverList' :key="index" @click="serveFlag = index">{{item.server_name}}</li>
					<li class="showMore" :class='serveMore?"less":"more"'  @click="showMore"></li>
				</ul>
				<div class="btn">
					<span class="cancel" @click="onCloseModalClick">取消</span>
					<span class="confirm" @click="submitServe">确定</span>
				</div>
		    </div>
		</common-modal>
		
		<!-- 选择卖家旺旺 -->
		<common-modal :showClose="true" v-if="isShowWang" @close-modal="onCloseModalClick">
		    <div class="modal">
		        <div class="title">选择卖家旺旺</div>
		        <ul class="wang-wrap">
		            <li v-for='(item,index) in wangList' :key='index'>
						<span class="modal-title">{{item.wangwang}}</span>
		                <span class="select-mark" :class='wangFlag==index?"done":"undone"' @click="wangFlag = index;"></span>
		            </li>
		        </ul>
		        <div class="modal-submit" @click="submitWang">确定</div>
		    </div>
		</common-modal>
		
		<!-- 协议弹框 -->
		<common-modal :showClose="true" v-if="isShowAgree" @close-modal="onCloseModalClick" class="agree-wrap">
		    <div class="modal agree-modal">
				<div class="title agree-title">用心淘下单协议</div>
		        <div class="order-detail">
		            <div class="agree-text">
<!--		               <p>1、处理期间，请拉黑或不与消费者联系、不对评价回复或解释（已回复的不影响处理）；</p>
		               <p>2、处理周期为五天，期限内撤单须扣除该订单付款金额50%违约金，五天期限后可正常申请退款 ；</p>
		               <p>3、五天处理期限内，不自行或交由他人处理，期限内解决的订单，都代表任务完成，应当收取费用 。</p> -->
                  <p>1，订单处理期间，为避免双方同时跟进，口吻不一，产生不必要矛盾，延误订单，下单后请不与顾客联系；</p>
                  <p>2，订单处理期间，为提高处理效率，打消处理人员顾虑，订单处理期间成功订单都认定为处理人员功劳，请商家勿自行或交由他人处理；</p>
                  <p>
                    3，订单周期为5天，据单子难易，时效有长短，确保订单高效、有序处理，处理期间中途撤单，为违约，须承担50% 违约责任。
                  </p>
		            </div>
		        </div>
				<div class="agree-submit" @click="isShowAgree=false;imgFlag=true">同意</div>
		    </div>
		</common-modal>
		
        <ul class="service-all">
            <li>
                <div class="service-pro have-border">
					<img src="@/assets/images/order-manage/ic_home_line_7.png" alt="" class="server-icon">
                    <span class="service-l key-wrap">服务项目<span class="key">*</span></span>
                </div>

                <div class="service-pro" @click="isShowService=true">
                    <span class="service-left service-type">{{serverName}}</span>
                    <span class="service-price"><span>&nbsp;</span><span v-show="serverPrice">¥</span>{{serverPrice}}</span>
                </div>
            </li>
            
            <li class="info-wrap">
				<div class="service-pro have-border no-pd">
					<img src="@/assets/images/order-manage/ic_home_line_8.png" alt="" class="server-icon">
				    <span class="service-l key-wrap">联系信息<span class="key">*</span></span>
				</div>
				<div class="service-content" v-for='index in linkNum' :key="index">
					<span class="service-left" v-text='serverType==1?"商品链接":"商家网址"'></span>
					<input class="service-right add-right" placeholder='请复制宝贝链接或淘口令' type="text" v-model='goodsLinkUrl[index-1]'>
					<img src="@/assets/images/order-manage/ic_add.png" class="add-url" @click='linkNum++' v-show="index==1">
					<img src="@/assets/images/order-manage/ic_shanchu.png" class="add-url" @click='linkNum--' v-show="index!=1">
				</div>
				<div  v-if="serverType==1">
					<div class="service-content">
					    <span class="service-left">卖家旺旺</span>
					    <input class="service-right add-right" placeholder="请输入卖家旺旺" type="text" :maxlength="20" v-model="info.merchantWang">
						<img src="@/assets/images/order-manage/ic_common.png" class="add-url" @click="selectUsedWang">
					</div>
					<div class="service-content">
					    <span class="service-left">买家旺旺</span>
					    <input class="service-right " placeholder="请输入买家旺旺" type="text" :maxlength="20" v-model="info.consumerWang">
					</div>
				</div>
				
				<div v-else>
					<div class="service-content">
					    <span class="service-left">顾客手机</span>
					    <input class="service-right" placeholder="请输入顾客手机号" type="text" :maxlength="20" v-model="info.consumerMobile">
					</div>
					<div class="service-content">
					    <span class="service-left">顾客姓名</span>
					    <input class="service-right" placeholder="请输入顾客姓名" type="text" v-model="info.consumerName">
					</div>
				</div>
            </li>
			
			<li class="info-wrap">
				<div class="service-pro have-border no-pd">
					<img src="@/assets/images/order-manage/ic_home_line_5.png" alt="" class="server-icon">
					<span class="img-upload key-wrap">截图信息({{ addBody.feedback_images.length }}/9）<span class="key key-img">*</span></span>
					<span class="img-expmle" @click="lookExample">
						查看示例
						<img :src="item" ref="example" v-for="(item, ins) in imgList " :key="ins" @click="handleImgsClick(imgList,ins)"  alt="" class="upload_img">
					</span>
				</div>
				<p class="img-text">{{message}}</p>
			    <div class="img-list">
					<imageUpload  v-model="addBody.feedback_images" :limit="9"/>
			    </div>
			</li>
		</ul>
		
		<div class="service-all">
			<div class="info-wrap">
				<p class="optional">箭头内为非必填信息，填写有助于提高处理效率</p>
			</div>
		</div>
		
		<ul class="service-all" v-show="isShowOption">
			<!-- 情况备注 -->
			<li class="info-wrap">
				<div class="service-pro have-border no-pd">
					<img src="@/assets/images/order-manage/ic_home_line_9.png" alt="" class="server-icon">
				    <span class="service-l key-wrap key-content">情况备注</span>
				</div>
				
				<div class="tag-all">
					<div class="tag-wrap">
						<span v-for="(item,index) in tags" :key="index" :class='item.tagFlag?"current":""' @click="selectTag(item,index)">{{item.name}}</span>
					</div>
					<textarea rows="3" cols="20" class="link-detail" placeholder="* 备注" maxlength="500" v-model="info.caseDetails"></textarea>
					<div class="limit">
						<span class="word-length">{{info.caseDetails.length}}</span>
						<span class="limit-amount">/500</span>
					</div>
				</div>
			</li>
			
			<!-- 售后特权 -->
			<li class="info-wrap mb-n">
				<div class="service-pro have-border no-pd">
					<img src="@/assets/images/order-manage/ic_home_line_4.png" alt="" class="server-icon">
				    <span class="service-l key-wrap key-content">售后特权
						<img src="@/assets/images/order-manage/ic_question.png" alt="" class="tips" @click="isShowTips = true">
					</span>
				</div>
				
				<ul class="list-wrap no-pr">
				    <li v-for="(item,index) in shouHouList" :key="index" class="after-select">
				        <span class="select-mark" @click="selectAfter(item,index)" :class='shouHouFlag==index?"done":"undone"'></span>
				        <span class="modal-text">{{item}}</span>
				    </li>
					<li class="after-text" v-if="shouHouFlag==3">
						<textarea rows="3" cols="20" class="link-detail" placeholder="* 备注" v-model="info.otherMassage"></textarea>
					</li>
					<li class="service-content no-border mb-n top-border" v-if='shouHouFlag==1'>
						<span class="service-left no-pd">最大允许补偿金额</span>
						<input class="service-right money-pd" placeholder="请输入金额" type="tel" v-model="info.compensationPrice">
					</li>
					
				</ul>
			</li>
        </ul>
		
		<div class="service-all">
			<div class="info-wrap" @click="isShowOption=!isShowOption">
				<img src="@/assets/images/order-manage/ic_more_down.png" class="optional-more" v-show="!isShowOption">
				<img src="@/assets/images/order-manage/ic_more_up.png" class="optional-more" :class='isShowOption?"have-pt":""' v-show="isShowOption">
			</div>
		</div>
		
		<div class="agree-module">
			<div class="link-wrap" @click="imgFlag =!imgFlag">
				<span class="agree-img" :class='imgFlag? "agree" : "un-agree"'></span>
				<span class="link">查看并同意<span class="xie-yi" @click.stop="isShowAgree=true">《用心淘下单协议》</span></span>
			</div>
		</div>	
		
        <submit-pay @submitClick="submitClick" :money="serverPrice" :step="step"></submit-pay>
    </section>
</template>

<script>
	import CommonModal from '@/components/CommonModal';
	import imageUpload from '@/components/ImageUpload';
    import CommonHeader from '@/components/CommonHeader'
    import submitPay from '@/components/submitPay'
	import {getServer} from '@/api/home'
	import {placeOrder,getOrderHistory,getOrderDetail,getUserWangWang,getQuickTag} from '@/api/order'
	import {getCommunal,WechatParLogin} from '@/api/common'
    import utils from '@/assets/jslibs/utils'

  import wx from "weixin-js-sdk";
    export default {
        name: 'service-order',
		data(){
			return{
				wangList:[],
				wangFlag:0,
				linkFlag:false,					//增加商品链接的标示,true则表示点击增加
				linkNum:1,						//默认链接数量
				serveMore:false,
				serveFlag:0,					//选中的服务项目
				tagFlag:-1,    //选中的标签
				clickTagList:JSON.parse(sessionStorage.getItem("clickTagList")) || [],
				isShowTips:false,
				isShowOption:false,
				isShowService:true,
				isShowWang:false,
				isShowAgree:false,
				imgFlag:false,
                imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				step:"下一步",
				limit:9,      			//限制图片数量
				serverList:[],			//服务项目
				serverPrice:"",
				serverName:"",
				serverType: "",
				serverUuid:"",
				caseImg:"" ,//该服务项目的案例图片
				message: "" ,  //案例描述
				tags:[],
				
				// 售后服务类型
				shouHouList:['除处理费用外，商家还同意消费者申请退货退款','除处理费用外，商家还愿意额外支付消费者补偿款','除处理费用外，商家还同意消费者不退货仅退款','其他'],
				// 售后服务类型选择标识
				shouHouFlag:-1,
				afterSale:"",
				info:{
					linkUrl:"",
					consumerName:"",  
					consumerWang:"",
					consumerMobile:"",
					// 商家
					merchantWang:"",
					compensationPrice:"",  //售后特权补偿金额
					otherMassage:"", 	 //售后特权其它
					caseDetails:""      //备注情况
				},
				addBody: {
				  feedback: '',
				  feedback_images: [],
				},
				imgList:[],
				goodsLinkUrl:[]
			}
			
		},
		
		beforeCreate(){
			//直接标记为用户端
			sessionStorage.setItem("roleType","customer")
		},
		
		created(){
			//微信静默授权获取code
      var ua = window.navigator.userAgent.toLowerCase();
      let that = this;

			if(ua.match(/MicroMessenger/i) == 'micromessenger' && (utils.getCookie('X-Access-Token') || sessionStorage.getItem('X-Access-Token'))){//微信并且登录
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
          } else {
            that.getWechatCode();
          }
        });
			}
			this.getCommunal();
			
			this.imgList = this.caseImg;
			if(this.imgList && this.imgList.length){
				this.imgList.forEach((idx,key)=>{
					if(idx.indexOf("https" || "http") == -1){
						this.imgList[key] = this.imgUrl + this.imgList[key]
					}
				})
			}
            
			//获取用户上次填写商家信息
			//获取服务项目
			this.getOrderHistory();
			this.getServer();
            this.getQuickTagList();
            if(sessionStorage.getItem("placeOrderId")){//从订单确认页返回
                var orderId = sessionStorage.getItem("placeOrderId");
                this.getOrderDetail(orderId);
            }
			if(sessionStorage.getItem("isSelect") && sessionStorage.getItem("isSelect")=="select"){//只要操作过了服务弹框，说明以及选择了服务项目，那么不在自动弹
				this.isShowService = false
			}
		},
        
        mounted(){
			document.title = "用心淘下单平台";
			let self = this;
			window.addEventListener('touchmove', (event)=>{ 
		       if(this.isShowService || this.isShowTips || this.isShowAgree || this.isShowWang){
		           event.preventDefault(); 
		       }
			}) 
        },
		
        methods: {
			//判断是否获取用code

			
			// 静默授权
			async wechatParLogin(code){
			    let obj = {code:code}
			    const { status,data } = await WechatParLogin(obj);
			    if (status !== 200) return
			}, 
			
			//获取七牛信息
			async getCommunal() {
				const { data, status } = await getCommunal();
				if (status !== 200) return 
				this.imgUrl = data.BucketDomain;
			    this.$store.commit("setImgUrl",data.BucketDomain);
				sessionStorage.setItem("imgUrl",data.BucketDomain);
			},

          async getWechatCode(){
            const code = utils.getQueryString('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
            const appId = "wxf3c9d00e530fedd8";
            const url = window.location.href;
            if (code == null || code === '') {
              window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
            } else {
              this.wechatParLogin(code) //把code传给后台获取用户信息
            }
          },
			
			//获取服务项目
			async getServer(){
				const { data, status } = await getServer();
				if (status !== 200) return
				this.serviceContent = data.char;
				this.serverList = this.serviceContent.slice(0,4);
				this.serverName = this.serverList[0].server_name;			//默认显示第一个项目
				this.serverPrice = this.serverList[0].server_price;
				this.serverType = this.serverList[0].type;
				this.serverUuid = this.serverList[0].uuid;       //服务id
				this.caseImg = this.serverList[0].case_img;
				this.message = this.serverList[0].message;     //案例描述
				this.imgList = this.caseImg;
				if(this.imgList && this.imgList.length){
					this.imgList.forEach((idx,key)=>{
						if(idx.indexOf("https" || "http") == -1){
							this.imgList[key] = this.imgUrl + this.imgList[key]
						}
					})
				}
			},
            
            //获取情况备注
            async getQuickTagList(){
            	const { data, status } = await getQuickTag();
            	if (status !== 200) return
            	this.tags = data.data;
				if(this.clickTagList.length){
					this.clickTagList.forEach((obj,idx)=>{
						this.tags.forEach((item,index)=>{
							this.$set(this.tags[obj],"tagFlag",true)
						})
					})
				}
            },
            
            //获取上次填写的下单信息，用于信息回填
            async getOrderDetail(order_uuid){
            	const { data, status } = await getOrderDetail(order_uuid);
            	if (status == 200){ 
                    this.serverName = data.server_info.server_name;
                    this.serverPrice = data.server_info.server_price;
                    this.serverType = data.server_info.type;
                    this.serverUuid = data.server_info.uuid;
                    this.caseImg = data.server_info.case_img;				//服务项目示例图片
                    this.message = data.server_info.message;
                    
                    this.imgList = JSON.parse(this.caseImg);
                    if(this.imgList && this.imgList.length){
                    	this.imgList.forEach((idx,key)=>{
                    		if(idx.indexOf("https" || "http") == -1){
                    			this.imgList[key] = this.imgUrl + this.imgList[key]
                    		}
                    	})
                    }

                    this.info.linkUrl = data.question_url;
					if(this.info.linkUrl){
						this.goodsLinkUrl = this.info.linkUrl.split(",");
						this.linkNum = this.goodsLinkUrl.length;
					}
                    this.info.consumerName = data.consumer_name;
                    this.info.consumerWang = data.consumer_wangwang;
                    this.info.consumerMobile = data.consumer_mobile;
                    this.info.merchantWang = data.merchant_wangwang;
					
                    this.afterSale = utils.typeToName(data.after_sale_type);     //售后特权
                    this.shouHouFlag = (data.after_sale_type) - 1;

                    this.info.compensationPrice = data.compensation_price;
                    this.info.otherMassage = data.other_sale_massage;
                    this.info.caseDetails = data.order_details;
                    this.addBody.feedback_images = data.order_images;
                }
            },
            
			//获取用户上次填写的商家信息	
			async getOrderHistory(){
				const { data, status } = await getOrderHistory();
				if (status !== 200) return
				if(data.data){
					this.info.merchantWang = data.data.merchant_wangwang;
				}
			},

			// 点击下一步
            submitClick(){
				if(!this.serverName || this.serverName=='请选择服务项目'){
					window.toast("请选择服务项目","txt");
					return
				}
				if(!this.goodsLinkUrl[0]){
					if(this.serverType=="1"){
						window.toast("请输入商品链接","txt");
						return
					}else{
						window.toast("请输入店铺链接","txt");
						return	
					}
					
				}	
				if(this.serverType=="1"){
					this.info.consumerMobile = "";		//置空非淘宝填写信息
					this.info.consumerName = "";
					if(!this.info.merchantWang){
						window.toast("请输入卖家旺旺","txt");
						return
					}
					if(!this.info.consumerWang){
						window.toast("请输入买家旺旺","txt");
						return
					}
				}else{
					this.info.merchantWang = "";		//置空淘宝填写信息
					this.info.consumerWang = "";
					// if(!(/^1[0123456789]\d{9}$/.test(this.info.consumerMobile))){
					// 	window.toast("顾客手机号有误","txt");
					// 	return
					// }
					if(!this.info.consumerMobile){
						window.toast("请输入顾客手机号","txt");
						return
					}
					if(!this.info.consumerName){
						window.toast("请输入顾客姓名","txt");
						return
					}
				}
				
				if(!this.addBody.feedback_images.length){
					window.toast("请上传截图信息","txt");
					return
				}
				if(this.info.caseDetails){
					if(this.info.caseDetails.length>500){
						window.toast("情况备注不得超过500字符","txt");
						return
					}
				}
				if(this.shouHouFlag=="1"){
					if(!(/^[1-9]\d*(,\d{3})*(\.\d{2})?$/).test(this.info.compensationPrice)){
						window.toast("补偿金输入有误","txt");
						return
					}
				}
				if(this.shouHouFlag=="3"){
					if(this.info.otherMassage.length>200){
						window.toast("售后特权其它情况不得超过200字符","txt");
						return
					}
				}
				this.goodsLinkUrl = this.goodsLinkUrl.filter((item,index)=>{
					return item!=""
				});
				this.info.linkUrl = this.goodsLinkUrl.join();
				if(!this.imgFlag ){
					window.toast('请勾选用心淘下单协议', 'txt');
					window.scrollTo(0,document.body.scrollHeight)
					return;
				}
				
				var obj={
					server_uuid:this.serverUuid,   		 //服务id
					server_type : this.serverType,  		 //服务类型(1,2)
					after_sale_type : this.shouHouFlag+1==0?"":this.shouHouFlag+1,    //售后类型 (1.2,3,4)
					question_url: this.info.linkUrl,  //链接
					consumer_name:this.info.consumerName,
					consumer_wangwang:this.info.consumerWang,
					consumer_mobile:this.info.consumerMobile,
					merchant_wangwang:this.info.merchantWang,
					compensation_price:this.info.compensationPrice,		//补偿金额
					other_sale_massage: this.info.otherMassage,       //其他情况
					order_images:this.addBody.feedback_images,
					order_details:this.info.caseDetails            //订单实际情况
				}
				this.placeOrder(obj)
            },
			
			// 服务下单
			async placeOrder(obj){
				const { data, status } = await placeOrder(obj);
				if (status !== 200) return 
                sessionStorage.setItem("placeOrderId",data.order_uuid);           //缓存下单服务下单生成的订单号，用户信息回填
				sessionStorage.setItem("clickTagList",JSON.stringify(this.clickTagList));
				this.$router.push({path:"./confirm-order",query: {order_uuid:data.order_uuid}});
			},

          //判断是否在微信小程序中

          async  isWx() {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              return new Promise(resolve => {
                wx.miniProgram.getEnv(function(res) {
                  if (res.miniprogram) {
                    resolve("mini-wx");
                  } else {
                    resolve("wx");
                  }
                });
              });
            } else {
              console.log("不在微信里");
              return new Promise(resolve => {
                resolve("no-wx");
              });
            }
          },



			//选择售后类型
			selectAfter(item,index){
				this.shouHouFlag = index;
				this.afterSale = item;
				if(this.shouHouFlag=="1"){
					this.otherMassage = ""
				}else if(this.shouHouFlag=="3"){
					this.compensationPrice = ""
				}
			},

			// 展开和收起服务项目
			showMore(){
				this.serveMore = !this.serveMore;
				if(this.serveMore){
					this.serverList = this.serviceContent;
				}else{
					this.serverList = this.serviceContent.slice(0,4);
				}
			},
			
			//确定服务项目
			submitServe(){
				sessionStorage.setItem("isSelect","select");
				this.serverName = this.serverList[this.serveFlag].server_name;
				this.serverPrice = this.serverList[this.serveFlag].server_price;
				this.serverType = this.serverList[this.serveFlag].type;
				this.serverUuid = this.serverList[this.serveFlag].uuid;       //服务id
				this.caseImg = this.serverList[this.serveFlag].case_img;
				this.message = this.serverList[this.serveFlag].message;     //案例描述
				this.imgList = this.caseImg;
				if(this.imgList && this.imgList.length){
					this.imgList.forEach((idx,key)=>{
						if(idx.indexOf("https") == -1){
							this.imgList[key] = this.imgUrl + this.imgList[key]
						}
					})
				}
				this.isShowService = false;
			},
			
			//获取用常用旺旺号
			async selectUsedWang(){
				const { data, status } = await getUserWangWang();
				if (status !== 200) return;
				if(data.char && data.char.length > 0){
					if(data.char.length > 10){
						this.wangList = data.char.slice(0,10);
					}else{
						this.wangList = data.char;
					}
					this.isShowWang=true;
				}else{
					window.toast('您暂无常用旺旺，请输入', 'txt');
				}
			},
		
			//确定旺旺
			submitWang(){
				this.info.merchantWang = this.wangList[this.wangFlag].wangwang;
				this.isShowWang = false;
			},
			
			// 查看你图片实例
			lookExample(){
				if(this.imgList && this.imgList.length){
					this.imgList.forEach((item,index)=>{
						this.handleImgsClick(this.imgList,index)
					})
				}
			},
			
			//放大图片
			handleImgsClick(item,index) {
				let self = this;
				if(item && item.length){
					self.initialIndex = index
					const params = {
						$props: {
						  imgs: item,
						  initialIndex: 'initialIndex', // 响应式数据的key名
						  loop: false
						},
						$events: {
							change: (i) => {
							// 必须更新 initialIndex
								self.initialIndex = i
							}
						}
					}
				  self.$createImagePreview({ ...params }).show()
				}
			},
			
			// 选择情况备注
			selectTag(item,index){
				if(!item.tagFlag){
					this.$set(item,"tagFlag",true);
					this.clickTagList.push(index)
					if(this.info.caseDetails && this.info.caseDetails.slice(-1)!=","){//手动输入没有输入逗号，则选择下个标签的时候前面要加上
						this.info.caseDetails += ","+item.name+',';
					}else{
						this.info.caseDetails += item.name+',';
					}
					
				}
				else{
					this.$set(item,"tagFlag",false);
					this.clickTagList.forEach((obj,idx)=>{
						if(obj == index){
							this.clickTagList.splice(idx,1);
						}
					})
					this.info.caseDetails = this.info.caseDetails.replace(item.name+',',"")
				}
			},
			
			// 关闭弹框
			onCloseModalClick(){
				sessionStorage.setItem("isSelect","select");
				this.shouHouFlag = -1      //用户关闭弹框，那么售后服务清空，只有点确定才算选择
				this.afterSale = "";
				this.isShowTips = false;
				this.isShowAgree = false;
				this.isShowWang = false;
				this.isShowService = false;
				document.body.style.overflow = "auto";
			},


		},
		
		components: {
			CommonModal,
		    CommonHeader,
		    submitPay,
			imageUpload
		}
    }
</script>

<style>
	.cube-picker-confirm {font-size: 15px;font-family: PingFangSC-Regular;font-weight: 400;color: rgba(65,132,244,1);}
	.cube-picker-cancel{font-size: 15px;font-family: PingFangSC-Regular;font-weight: 400;color:rgba(153,153,153,1)}
	.service-all .img-list .dankal-image-upload p{margin-right: 14px;margin-left: 0;}
	.service-all .img-list .dankal-image-upload p:nth-child(3n){margin-right: 0;}
	.service-all .img-list .dankal-image-upload .add-box{padding-left: 0;}
	.agree-wrap .modal-content{position: fixed;bottom: 0;left: 0;right: 0;}
	.agree-wrap .modal-content .close-icon{right: -9.0rem;}
	.agree-wrap .modal-content .modal,.service-wrap .modal-content .modal{padding-bottom:0;}
	.service-wrap .modal-content .service-box{width: 280px;border-radius:8px;}
	.order-wrap .submit-pay{bottom: 52px;}
</style>

<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	::-webkit-input-placeholder { color:#999999;opacity: 0.3;}
	::-moz-placeholder {color:#909;opacity: 0.4;}
	::-moz-placeholder {color:#909;opacity: 0.4;}
	::-ms-input-placeholder {color:#909;opacity: 0.4;}
    section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5;padding: 10px 10px 0 10px;}
    /* .service-all{padding-bottom:72px;} */
	.agree-module{padding-bottom:120px;}
	.service-all li{margin-bottom: 10px;}
	.service-all .info-wrap{padding: 0 10px;background: #fff}
	.info-wrap .optional{padding: 10px 0 10px 0;text-align:center;font-size:13px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(153,153,153,1);}
	.info-wrap .optional-more{width:20px;height:16px;margin: 0 auto;display: block;padding: 10px 0;box-sizing: content-box;}
	.service-pro{display: -webkit-box;display: -ms-flexbox;display: flex;align-items: center;height: 52px;padding: 0 10px;background: #fff}
	.m-d{padding-bottom: 14px;border-bottom: 0.026667rem solid #EEEEEE;}
    .service-l{color: rgba(51,51,51,1);font-size: 15px}
    .service-title{.f-s(14);.p-t(10);.p-b(10);.p-l(16);color:rgba(153,153,153,1);}
	.tips{width:14px;height:14px;margin-left: 7px;}
    .service-content{position: relative;.h(52);.l-h(52);display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;border-bottom: 1px solid #EEEEEE;align-items: center;background: #fff}
	.server-icon{.w(19.5);.h(20);.m-r(5.5)}
    .service-left{color:rgba(51,51,51,1);text-align: justify;display: inline-block;vertical-align: top;.f-s(15);padding-left: 8px;padding-right: 14px}
    .service-price{font-size:15px;color:rgba(51,51,51,1);text-align: right;-webkit-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;padding-right: 26px;background: url(../assets/images/home/ic_home_enter.png) right center no-repeat;background-size: 6px;}
    .service-right{.f-s(16);border: 0;display: inline-block;vertical-align: top;color: rgba(51,51,51,1);text-align: right;-webkit-box-flex: 0.9;-webkit-flex: 0.9;-ms-flex: 0.9;flex: 0.9;padding-right: 24px}
    .right-arrow-wrap{-webkit-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}
	.arrow{margin-top: 20px}
	.service-case{display: block;height:52px;line-height:52px;padding-right: 18px;float: right;font-size:16px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(51,51,51,1);font-style: normal;background: url(../assets/images/home/ic_home_enter.png) right 50% no-repeat;background-size: 9px;}
    .right-arrow{display: block;.w(9);.h(15);float: right;background: url(../assets/images/home/ic_home_enter.png) right 50% no-repeat;background-size: contain;overflow: hidden;}
    .goods-left{display: block}
	.area-pt{padding-top: 0.42666667rem;}
	.link-detail{width: 328px;height: 155px;color: #000;padding: 10px 15px 15px 15px;background: rgba(245,245,245,1);appearance: none;border-radius: 2px;border: 1px solid rgba(207,207,207,1);outline: none;line-height:19px;font-size:14px;resize: none;font-family:PingFangSC-Regular,PingFang SC;}
	.limit{position: absolute;bottom: 0.56rem;right: 0.4rem;}
	.service-pay{font-size:16px;color: #333333}
	.img-upload{font-size:15px;color:rgba(51,51,51,1);}
	.img-expmle{font-size:14px;color:rgba(255,134,48,1);flex: 1;text-align: right;}
	.img-text{font-size:12px;color:rgba(153,153,153,1);padding: 10px 0 10px 10px;background: #fff}
    .img-list{padding: 0 8px;display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;justify-content: space-between;background: #fff}
    .img-list div{margin-bottom: 16px}
    .img-arr{width: 97px;height: 95px}
    .no-border{border: none}
    .have-border{border-bottom: 1px solid #EEEEEE;}
    .upload-img{width: 95px;height: 95px;background: url(../assets/images/home/ic_home_add.png) center center no-repeat;background-size: cover;}
	.change-style{font-size: 15px;font-family: PingFangSC-Regular;font-weight: 400;}
	.upload_img{display: none}
	/* 弹框 */
	.modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.agree-modal{width: 100%;}
	.title{padding: 12px 21px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
	.agree-title{padding-left: 25px;padding-right: 22px;text-align: left;font-family:PingFangSC-Semibold,PingFang SC;font-weight:600;color:rgba(20,20,20,1);}
	.list-wrap{padding:15px 5px 0 5px;}
	.list-wrap li{margin-bottom: 10px}
	.list-wrap li:nth-last-child(1){margin-bottom: 0}
	.select-mark{display: inline-block;width:17px;height:17px;margin-right: 5px;vertical-align: top;box-sizing: content-box}
	.done{background: url(../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.modal-text{display: inline-block;font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);vertical-align: top;}
	.modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}
	.tips-all{width: 8.533333rem;background: #fff;margin: 0 auto;font-size: 18px; padding: 40px 20px 20px 20px;}

	/* 协议弹框 */
	.order-detail{margin-bottom: 10px;background: #fff}
	.link-wrap{text-align: center;font-size: 0;height:60px;margin: 0 10px;line-height:60px;}
	.link{display: inline-block;vertical-align: middle;color:rgba(174,174,174,1);font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;}
	.xie-yi{color:rgba(65,132,244,1);}
	.agree-img{width: 14px;height: 14px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.agree{background: url(../assets/images/home/pic_right2_pitchon.png) center center no-repeat;background-size: cover}
	.un-agree{background: url(../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.agree-text{padding: 20px 25px 30px 25px}
	.agree-text p{font-size:14px;color: rgba(51,51,51,1);line-height:20px;margin-bottom: 18px;letter-spacing: 1.5px;}
	.agree-submit{width:100%;height:48px;line-height: 48px;text-align: center;background:rgba(65,132,244,1);border-radius:1px;font-size:15px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(255,255,255,1);}
	
	/* 服务项目 */
	.btn{display: flex;justify-content:space-between;align-items:center;padding: 15px 20px 7.5px 20px;font-size:16px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400}
	.btn .cancel{;color:rgba(174,174,174,1);}
	.btn .confirm{color:rgba(65,132,244,1);}
	.service-h1{background: rgba(65,132,244,0.2);font-size: 16px;font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;color: rgba(65,132,244,1);}
	.service-detail{padding-top: 16px;height: 216px;overflow-y: auto;}
	.service-more{height: 360px;}
	.service-detail .detail{width:160px;height:34px;padding: 0 0.2rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;;line-height: 34px;margin: 0 auto 9px auto;border-radius:4px;background:rgba(102,102,102,0.06);border:1px solid rgba(193,193,193,1);color:rgba(51,51,51,1);text-align:center;font-size:14px;font-family:PingFangSC-Medium,PingFang SC;font-weight:500;}
	.service-detail .select{background:rgba(65,132,244,0.1);border:1px solid rgba(65,132,244,0.5);color:rgba(65,132,244,1);}
	.service-detail .showMore{width: 15px;height:9px;margin: 13px auto 12px auto;}
	.service-detail .more{background: url(../assets/images/order-manage/ic_down.png) center center no-repeat;background-size: cover;}
	.service-detail .less{background: url(../assets/images/order-manage/ic_up.png) center center no-repeat;background-size: cover;}
	
	/* 选择旺旺 */
	.wang-wrap{padding: 18px 20px 17px 20px;/* height: 500px;overflow: auto; */}
	.wang-wrap li{display: flex;justify-content: space-between;align-items:center;margin-bottom: 15px;}
	.modal-title{font-size:15px;color:rgba(20,20,20,1);max-width: 88%;}
	
	.key-wrap{position: relative;font-weight: 600;}
	.key-content{display: flex;align-items: center;}
	.key{position: absolute;right: -20%;top:-10%;color: #ff8630;}
	.key-img{right: -4%;}
	.add-url{width: 16px;height: 16px}
	.no-pd{padding-left: 0}
	.no-pr{padding-right: 0}
	.add-right{padding-right: 8px}
	.add-r{padding-right: 24px}
	.area-wrap{padding-bottom: 15px;}
	.have-pt{padding-top: 13px;}
	.current{background-image: url("../assets/images/order-manage/pic_order_right.png");background-repeat: no-repeat;background-position: top right;background-size: 23px;border:1px solid rgba(65,132,244,1);color:rgba(65,132,244,1);}
	.service-all .mb-n{margin-bottom: 0;}
	.list-wrap .after-text{margin-bottom: 17px;margin-top: 15px;}
	.after-select{display: flex;align-items: center;}
	.top-border{border-top: 0.026667rem solid #EEEEEE;}
	.no-h{height: 0;border: 0;}
	.money-pd{padding-right:18px;}
	.tag-all{
		position: relative;
		.p-t(21);
		.p-b(15);
		h1{
			.f-s(15);
			.m-b(10);
			font-family:PingFangSC-Medium;
			font-weight:500;
			color:rgba(20,20,20,1);
		}
		.tag-wrap{
			display: flex;
			flex-wrap: wrap;
			.select-style{
				border:1px solid rgba(255,134,48,1);
				background:rgba(255,245,237,1);
				color:rgba(255,134,48,1);
			}
			span{
				.m-r(16);
				.m-b(15);
				.p-t(7.5);
				.p-b(7.5);
				.p-l(10);
				.p-r(10);
				.f-s(14);
				background:rgba(245,245,245,1);
				border-radius:2px;
				font-family:PingFangSC-Regular;
				font-weight:400;
				color:rgba(76,76,76,1);
			}	
			.current{
				background-image: url("../assets/images/order-manage/pic_order_right.png");
				background-repeat: no-repeat;
				background-position: top right;
				background-size: 23px;
				border:1px solid rgba(65,132,244,1);
				color:rgba(65,132,244,1);
			}
		}
	}


</style>

